module.exports = __webpack_public_path__ + "static/media/wheelChairIcon.08b95331.svg";